/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { StepAuthentication } from './';
import {
    StepAuthenticationFromJSON,
    StepAuthenticationFromJSONTyped,
    StepAuthenticationToJSON,
} from './';
import type { StepCompanyChoice } from './';
import {
    StepCompanyChoiceFromJSON,
    StepCompanyChoiceFromJSONTyped,
    StepCompanyChoiceToJSON,
} from './';
import type { StepCompanyDetails } from './';
import {
    StepCompanyDetailsFromJSON,
    StepCompanyDetailsFromJSONTyped,
    StepCompanyDetailsToJSON,
} from './';
import type { StepEmailAwaitingValidation } from './';
import {
    StepEmailAwaitingValidationFromJSON,
    StepEmailAwaitingValidationFromJSONTyped,
    StepEmailAwaitingValidationToJSON,
} from './';
import type { StepPhoneNumber } from './';
import {
    StepPhoneNumberFromJSON,
    StepPhoneNumberFromJSONTyped,
    StepPhoneNumberToJSON,
} from './';
import type { StepPublicEmailWarning } from './';
import {
    StepPublicEmailWarningFromJSON,
    StepPublicEmailWarningFromJSONTyped,
    StepPublicEmailWarningToJSON,
} from './';
import type { StepRedirectUser } from './';
import {
    StepRedirectUserFromJSON,
    StepRedirectUserFromJSONTyped,
    StepRedirectUserToJSON,
} from './';
import type { StepUserDetails } from './';
import {
    StepUserDetailsFromJSON,
    StepUserDetailsFromJSONTyped,
    StepUserDetailsToJSON,
} from './';
import type { StepUserQualification } from './';
import {
    StepUserQualificationFromJSON,
    StepUserQualificationFromJSONTyped,
    StepUserQualificationToJSON,
} from './';

/**
 * 
 * @export
 * @interface SignupStep
 */
export interface SignupStep {
    /**
     * 
     * @type {string}
     * @memberof SignupStep
     */
    name: string;
}

/**
 * Check if a given object implements the SignupStep interface.
 */
export function instanceOfSignupStep(value: object): value is SignupStep {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SignupStepFromJSON(json: any): SignupStep {
    return SignupStepFromJSONTyped(json, false);
}

export function SignupStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupStep {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['name'] === 'StepAuthentication') {
            return StepAuthenticationFromJSONTyped(json, true);
        }
        if (json['name'] === 'StepCompanyChoice') {
            return StepCompanyChoiceFromJSONTyped(json, true);
        }
        if (json['name'] === 'StepCompanyDetails') {
            return StepCompanyDetailsFromJSONTyped(json, true);
        }
        if (json['name'] === 'StepEmailAwaitingValidation') {
            return StepEmailAwaitingValidationFromJSONTyped(json, true);
        }
        if (json['name'] === 'StepPhoneNumber') {
            return StepPhoneNumberFromJSONTyped(json, true);
        }
        if (json['name'] === 'StepPublicEmailWarning') {
            return StepPublicEmailWarningFromJSONTyped(json, true);
        }
        if (json['name'] === 'StepRedirectUser') {
            return StepRedirectUserFromJSONTyped(json, true);
        }
        if (json['name'] === 'StepUserDetails') {
            return StepUserDetailsFromJSONTyped(json, true);
        }
        if (json['name'] === 'StepUserQualification') {
            return StepUserQualificationFromJSONTyped(json, true);
        }
    }
    return {
        
        'name': json['name'],
    };
}

export function SignupStepToJSON(value?: SignupStep | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.name === 'StepAuthentication') {
            return StepAuthenticationToJSON(value as StepAuthentication);
        }
        if (value.name === 'StepCompanyChoice') {
            return StepCompanyChoiceToJSON(value as StepCompanyChoice);
        }
        if (value.name === 'StepCompanyDetails') {
            return StepCompanyDetailsToJSON(value as StepCompanyDetails);
        }
        if (value.name === 'StepEmailAwaitingValidation') {
            return StepEmailAwaitingValidationToJSON(value as StepEmailAwaitingValidation);
        }
        if (value.name === 'StepPhoneNumber') {
            return StepPhoneNumberToJSON(value as StepPhoneNumber);
        }
        if (value.name === 'StepPublicEmailWarning') {
            return StepPublicEmailWarningToJSON(value as StepPublicEmailWarning);
        }
        if (value.name === 'StepRedirectUser') {
            return StepRedirectUserToJSON(value as StepRedirectUser);
        }
        if (value.name === 'StepUserDetails') {
            return StepUserDetailsToJSON(value as StepUserDetails);
        }
        if (value.name === 'StepUserQualification') {
            return StepUserQualificationToJSON(value as StepUserQualification);
        }
    }
    return {
        
        'name': value['name'],
    };
}

